import { render } from "./HomepageKikirpa.vue?vue&type=template&id=79cdaf96&scoped=true"
import script from "./HomepageKikirpa.vue?vue&type=script&lang=js"
export * from "./HomepageKikirpa.vue?vue&type=script&lang=js"

import "./HomepageKikirpa.vue?vue&type=style&index=0&id=79cdaf96&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79cdaf96"]])

export default __exports__